module.exports = __webpack_public_path__ + "static/media/finance.ee7933b5.svg";